<div id="page--App Info">

  <p>Main Api - {{mainApiInfo}}</p>

</div>
